module.exports = __webpack_public_path__ + "static/media/camera.5c12e8f4.jpg";